<template>
  <svg :width="width"
       :height="height"
       viewBox="0 0 495.123 700.561"
  >
    <g id="Gruppe_2936" data-name="Gruppe 2936" transform="translate(-229.224 -109.823)">
      <path id="Pfad_19" data-name="Pfad 19" d="M30.21,394.43V114.239L195.362,44.15,525.333,184.329Z" transform="translate(199.014 415.954)" fill="#5c5a59"/>
      <path id="Pfad_20" data-name="Pfad 20" d="M30.21,23.11V303.3L195.362,373.39,525.333,233.378Z" transform="translate(199.014 86.713)" fill="#4dad34"/>
      <path id="Pfad_21" data-name="Pfad 21" d="M370.1,315.931,40.13,175.752,370.1,35.74Z" transform="translate(354.246 284.351)" fill="#cad400"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'LogoNoText',
  props: {
    color: {
      type: String,
      required: true
    },
    width: {
      required: false,
      default: ''
    },
    height: {
      required: false,
      default: ''
    }
  }
}
</script>

<style scoped>

</style>
